import React from 'react';
import { IOldIconProps } from './type';

const Pin: React.FC<IOldIconProps> = ({
  width,
  height,
  color = '#000',
  ...props
}) => {
  return (
    <svg
      width={width || 32}
      height={height || 32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8335 12.15C10.8335 9.02959 13.3631 6.5 16.4835 6.5C19.6039 6.5 22.1335 9.02959 22.1335 12.15C22.1335 13.7582 21.3851 16.4422 20.1978 19.1216C19.1523 21.4812 17.8266 23.7006 16.516 25.078C15.3251 23.6833 13.9976 21.4578 12.9145 19.1112C11.6707 16.4166 10.8335 13.7434 10.8335 12.15ZM16.4835 5C12.5347 5 9.3335 8.20116 9.3335 12.15C9.3335 14.0913 10.2963 17.018 11.5525 19.7398C12.8157 22.4764 14.4601 25.1872 15.9532 26.6803C16.2324 26.9595 16.6802 26.9744 16.9774 26.7144C18.7014 25.2059 20.3551 22.4692 21.5692 19.7293C22.7819 16.9925 23.6335 14.0764 23.6335 12.15C23.6335 8.20116 20.4323 5 16.4835 5ZM14.0335 12.95C14.0335 11.5969 15.1304 10.5 16.4835 10.5C17.8366 10.5 18.9335 11.5969 18.9335 12.95C18.9335 14.3031 17.8366 15.4 16.4835 15.4C15.1304 15.4 14.0335 14.3031 14.0335 12.95ZM16.4835 9C14.302 9 12.5335 10.7685 12.5335 12.95C12.5335 15.1315 14.302 16.9 16.4835 16.9C18.665 16.9 20.4335 15.1315 20.4335 12.95C20.4335 10.7685 18.665 9 16.4835 9Z"
        fill={color}
      />
    </svg>
  );
};

export default Pin;
